<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id===undefined?$route.query.plate:$route.query.id">
    <VehicleDetailContent slot-scope="{data}"  :status="data.status" :form-data="data.formData"></VehicleDetailContent>
  </l-cache>
</template>
<script>
import VehicleDetailContent from './vehicleDetailContent'
export default {
  components: {VehicleDetailContent},
  methods: {
    async getItem (key) {
      let searchParam = {}
      if(this.$route.query.id!==undefined){
         searchParam = {
          'searchParam': {
            'id': {
              'index': '1',
              'order': 'DESC',
              'operators': [
                {
                  'keyword': this.$route.query.id,
                  'operator': 'LIKE',
                  'matchType': 'NONE'
                }
              ]
            },
          }
        }
      }else{
        searchParam = {
          'searchParam': {
            'plateNumber': {
              'index': '1',
              'order': 'DESC',
              'operators': [
                {
                  'keyword': this.$route.query.plate,
                  'operator': 'LIKE',
                  'matchType': 'NONE'
                }
              ]
            },
            'status': {
              'index': '2',
              'order': 'DESC',
              'operators': [
                {
                  'keyword': '1',
                  'operator': 'LIKE',
                  'matchType': 'NONE'
                }
              ]
            },
          }
        }
      }
      let res = await this.$store.dispatch('vehicleRegister/getVehicleList', {searchParam: searchParam, pagination: {page: 1, rowsPerPage: 10}})
      if (res.data.status === 1) {
        let data = {
          formData: res.data.data.content[0],
          status: this.$route.query.status
        }
        return data
      }
      else {
        this.$L.alert('error', {message: '查询车辆信息错误，原因:' + res.data.msg})
      }
    }
  }
}
</script>
